export const state = () => ({
	notifications: {},
	notifications_tab: null,
	scroll_position: 0,
	cursor: null,
	unreadBoolean: false,
});

export const mutations = {
	setNotifications(state: any, payload: any) {
		state.notifications = payload;
	},
	setNotificationsTab(state: any, payload: any) {
		state.notifications_tab = payload;
	},

	setScrollPosition(state: any, payload: any) {
		state.scroll_position = payload;
	},

	setCursor(state: any, payload: any) {
		state.cursor = payload;
	},

	setUnreadBoolean(state: any, payload: any) {
		state.unreadBoolean = payload;
	},
};

export const getters = {
	getNotifications: (state: any) => state.notifications,

	getNotificationsTab: (state: any) => state.notifications_tab,

	getScrollPosition: (state: any) => state.scroll_position,

	getCursor: (state: any) => state.cursor,

	getUnreadBoolean: (state: any) => state.unreadBoolean,
};

export const actions = {
	checkForUnread(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/notifications', { params: { read: 0 } })
				.then((res) => {
					if (!res.data.data.length) {
						state.commit('setUnreadBoolean', false);
					} else {
						state.commit('setUnreadBoolean', true);
					}

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getNotifications(state: any, payload: any) {
		let url = payload?.url || '/api/notifications';

		let params = {
			cursor: state.state.cursor,
			read: payload?.read,
		};

		Object.keys(params).forEach((key) => {
			if (params[key] === null || params[key] === '') delete params[key];
		});

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url, { params })
				.then((res) => {
					let notifications = JSON.parse(
						JSON.stringify(state.state.notifications),
					);

					if (params.cursor) {
						notifications.data.push(...res.data.data);
						notifications.links = res.data.links;
						notifications.meta = res.data.meta;
					} else {
						notifications = res.data;
					}
					state.commit('setNotifications', notifications);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	toggleNotificationStatus(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/notifications/status-toggle', payload)
				.then((res) => {
					let updated = JSON.parse(JSON.stringify(state.state.notifications));

					updated.data.forEach((object, index) => {
						if (!payload.notifications.includes(object.id)) return;
						updated.data[index].read_at = payload.read ? new Date() : null;
					});

					state.commit(
						'setUnreadBoolean',
						Boolean(updated.data.filter((n) => !n.read_at).length),
					);
					state.commit('setNotifications', updated);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	deleteNotifications(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/notifications', { data: payload })
				.then((res) => {
					let clonedNotifications = JSON.parse(JSON.stringify(state.state.notifications));

					// Remove the specified notifications from state.
					clonedNotifications.data = clonedNotifications.data.filter((item) => (
						!payload.notifications.includes(item.id)
					));

					state.commit('setNotifications', clonedNotifications);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateNotificationsTab(state: any, payload: any) {
		state.commit('setNotificationsTab', payload);
	},

	setCursor(state: any, payload: any) {
		state.commit('setCursor', payload);
	},

	setScrollPosition(state: any, payload: any) {
		state.commit('setScrollPosition', payload);
	},
};
